import type { TableProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import { FormkitTable } from "src/components/destinations/table";
import type { SharedProps } from ".";

export const FKTable = ({
  name,
  columns,
  addRow,
  addRowLabel,
  compact,
  isDisabled,
  isSetup,
}: TableProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <FormkitTable
        isDisabled={isDisabled}
        addRow={addRow}
        addRowLabel={addRowLabel}
        compact={compact}
        columns={columns}
        value={field.value}
        onChange={field.onChange}
        isSetup={isSetup}
      />
    )}
  />
);
